"use strict";

var _regeneratorRuntime = require("/home/runner/work/metamask-link/metamask-link/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/runner/work/metamask-link/metamask-link/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require("../util/errors"),
    ParserError = _require.ParserError;

var yaml = require("js-yaml");

module.exports = {
  /**
   * The order that this parser will run, in relation to other parsers.
   *
   * @type {number}
   */
  order: 200,

  /**
   * Whether to allow "empty" files. This includes zero-byte files, as well as empty JSON objects.
   *
   * @type {boolean}
   */
  allowEmpty: true,

  /**
   * Determines whether this parser can parse a given file reference.
   * Parsers that match will be tried, in order, until one successfully parses the file.
   * Parsers that don't match will be skipped, UNLESS none of the parsers match, in which case
   * every parser will be tried.
   *
   * @type {RegExp|string[]|function}
   */
  canParse: [".yaml", ".yml", ".json"],
  // JSON is valid YAML

  /**
   * Parses the given file as YAML
   *
   * @param {object} file           - An object containing information about the referenced file
   * @param {string} file.url       - The full URL of the referenced file
   * @param {string} file.extension - The lowercased file extension (e.g. ".txt", ".html", etc.)
   * @param {*}      file.data      - The file contents. This will be whatever data type was returned by the resolver
   * @returns {Promise}
   */
  parse: function parse(file) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // eslint-disable-line require-await
              data = file.data;

              if (Buffer.isBuffer(data)) {
                data = data.toString();
              }

              if (!(typeof data === "string")) {
                _context.next = 12;
                break;
              }

              _context.prev = 3;
              return _context.abrupt("return", yaml.load(data));

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](3);
              throw new ParserError(_context.t0.message, file.url);

            case 10:
              _context.next = 13;
              break;

            case 12:
              return _context.abrupt("return", data);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 7]]);
    }))();
  }
};